import { createWalletId as _createWalletId } from '../syncWallet';
import { updateStoredValues } from '../helpers';
export default function createWalletId(_ref, walletStorageService) {
  let {
    types
  } = _ref;
  return () => async (dispatch, getState) => {
    const paymentsInfo = getState()?.payments;
    const isLoggedIn = getState()?.auth?.isLoggedIn || false;
    const id = await _createWalletId({
      walletStorageService,
      paymentInfo: paymentsInfo,
      isLoggedIn
    });
    dispatch({
      type: types.SET_WALLET_ID,
      payload: id
    });
    walletStorageService.setWalletId(id);
    const response = await updateStoredValues({
      paymentsInfo,
      payments: {
        walletId: id
      },
      walletStorageService,
      isLoggedIn
    });
    if (!response?.success) {
      dispatch({
        type: types.UPDATE_MY_WALLET,
        payload: {
          displayWalletErrorMessage: true
        }
      });
    }
  };
}